import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
  {
    n: "01",
    ar: "ٱلْخُطَّة",
    title: "Un plan, pas de la pression",
    text: "Chaque guide ouvre sur un planning structuré, jour par jour. Tu sais exactement quoi mémoriser ou réviser chaque matin — la charge mentale disparaît, il ne reste que l'essentiel.",
  },
  {
    n: "02",
    ar: "ٱلتَّكْرَار",
    title: "La répétition qui ancre",
    text: "Des techniques de mémorisation et de révision espacée, éprouvées par ceux qui ont appris avant toi. Peu de pages, beaucoup de régularité : c'est ainsi que le Coran s'installe durablement.",
  },
  {
    n: "03",
    ar: "ٱلْمُتَابَعَة",
    title: "Chaque jour compte",
    text: "Un suivi de progression simple pour visualiser le chemin parcouru. Voir les jours s'accumuler est le meilleur carburant contre les périodes de découragement.",
  },
  {
    n: "04",
    ar: "ٱلنِّيَّة",
    title: "Le cœur avant la mémoire",
    text: "Au-delà de la méthode, chaque guide nourrit la motivation spirituelle. Parce qu'on ne mémorise pas seulement des mots — on se rapproche de son Seigneur.",
  },
];

export default function Chapters() {
  return (
    <section className="chapters" id="methode" data-testid="methode-section">
      <div className="container">
        <motion.div
          className="section-head"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: EASE }}
        >
          <div className="eyebrow">La méthode</div>
          <h2>Quatre principes,<br />une seule direction</h2>
          <p>Comment ça marche : une approche simple, pensée pour durer.</p>
        </motion.div>

        <div className="chapter-list">
          {CHAPTERS.map((c, i) => (
            <motion.article
              className="chapter"
              key={c.n}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, delay: 0.08, ease: EASE }}
              data-testid={`chapter-${c.n}`}
            >
              <div className="chapter-num" aria-hidden="true">{c.n}</div>
              <div className="chapter-body">
                <div className="chapter-ar">{c.ar}</div>
                <h3>{c.title}</h3>
                <p>{c.text}</p>
              </div>
              <motion.div
                className="chapter-line"
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 1.2, delay: 0.2, ease: EASE }}
                aria-hidden="true"
              />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
